<template>
  <div class="credit-memo-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "creditMemoBase",
};
</script>
